/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubjectPatchModel } from '../../models/subject-patch-model';
import { SubjectResponse } from '../../models/subject-response';

export interface PatchApiSubjectV1Id$Plain$Params {
  id: number;

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
  
    /**
     * Dati patch con struttura {isModified, value} per ogni campo.
     */
    body?: SubjectPatchModel
}

export function patchApiSubjectV1Id$Plain(http: HttpClient, rootUrl: string, params: PatchApiSubjectV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SubjectResponse>> {
  const rb = new RequestBuilder(rootUrl, patchApiSubjectV1Id$Plain.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubjectResponse>;
    })
  );
}

patchApiSubjectV1Id$Plain.PATH = '/private/v1/subjects/{id}';
